module.exports = __webpack_public_path__ + "static/media/clock.dc3ea897.png";